import { render, staticRenderFns } from "./application.vue?vue&type=template&id=1345701a&scoped=true&"
import script from "./application.vue?vue&type=script&lang=ts&"
export * from "./application.vue?vue&type=script&lang=ts&"
import style0 from "./application.vue?vue&type=style&index=0&id=1345701a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1345701a",
  null
  
)

export default component.exports